import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "fp_token";
const ROLE_KEY = "fp_role";
const USER_KEY = "fp_user";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getRole: () => localStorage.getItem(ROLE_KEY),
  getUser: () => {
    const raw = localStorage.getItem(USER_KEY);
    try { return raw ? JSON.parse(raw) : null; } catch { return null; }
  },
  setSession: (token, role, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ROLE_KEY, role);
    localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLE_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const token = auth.getToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Soft kick: clear, but let pages decide redirect
      auth.clear();
    }
    return Promise.reject(err);
  }
);

export const STATUS_LABELS = {
  new_lead: "New Lead",
  contacted: "Contacted",
  documents_requested: "Documents Requested",
  submitted_to_lender: "Submitted to Lender",
  offer_received: "Offer Received",
  funded: "Funded",
  declined: "Declined",
  commission_paid: "Commission Paid",
};

export const STATUS_CLASS = {
  new_lead: "bg-blue-100 text-blue-800 border-blue-200",
  contacted: "bg-purple-100 text-purple-800 border-purple-200",
  documents_requested: "bg-amber-100 text-amber-800 border-amber-200",
  submitted_to_lender: "bg-indigo-100 text-indigo-800 border-indigo-200",
  offer_received: "bg-teal-100 text-teal-800 border-teal-200",
  funded: "bg-emerald-100 text-emerald-800 border-emerald-200",
  declined: "bg-rose-100 text-rose-800 border-rose-200",
  commission_paid: "bg-slate-900 text-white border-slate-900",
};

export const STATUS_ORDER = [
  "new_lead",
  "contacted",
  "documents_requested",
  "submitted_to_lender",
  "offer_received",
  "funded",
  "declined",
  "commission_paid",
];

export const formatMoney = (n) =>
  (Number(n) || 0).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
